import { Component, Input, OnInit } from '@angular/core';
import { GroupUsersService } from '../../services/group-users.service';
import { Observable, take } from 'rxjs';
import { User } from '@shared/models/user';
import { LoadingState } from '@shared/types/loading-state';
import { ModalController } from '@ionic/angular';
import { regexList } from '@shared/constants/regex-list';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-user-selector-container',
  standalone: false,
  templateUrl: './user-selector-container.component.html',
  styleUrl: './user-selector-container.component.scss',
})
export class UserSelectorContainerComponent implements OnInit {
  @Input() showRemoveOwner = false;
  groupUsers$: Observable<User[]>;
  loadingState$: Observable<LoadingState>;
  userSearchFormGroup: FormGroup;
  regexList = regexList;

  constructor(
    private groupUsersService: GroupUsersService,
    private modalController: ModalController,
  ) {}

  ngOnInit() {
    this.groupUsers$ = this.groupUsersService.getFilteredGroupUsers({});
    this.loadingState$ = this.groupUsersService.getGroupUsersLoading();

    this.groupUsers$.pipe(take(1)).subscribe((users) => {
      if (users.length === 0) {
        this.groupUsersService.loadGroupUsers();
      }
    });
    this.userSearchFormGroup = new FormGroup({
      userSearchInput: new FormControl(''),
    });
  }

  closeModal() {
    this.modalController.dismiss({});
  }

  selectedUser(user: User) {
    this.modalController.dismiss({ user: user });
  }

  removeOwner() {
    this.modalController.dismiss({ removeOwner: true });
  }

  filterGroupUsers() {
    const searchValue = this.userSearchFormGroup.controls['userSearchInput'].value;
    this.groupUsers$ = this.groupUsersService.getFilteredGroupUsers({ full_name: searchValue });
  }
}
